// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3tVrp","col":"styles_col__AZBua"};